"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	adult: "Adult",
	animals: "Animals",
	achitecture_design: "Architecture & Design",
	beauty: "Beauty",
	wellness_health: "Health and Wellness",
	business: "Business",
	culture: "Culture (Art, literature...)",
	education_knowledge: "Education and Knowledge",
	entertainment: "Entertainment (cinema, TV...)",
	family: "Family",
	food_drinks: "Food & Drinks",
	gaming: "Gaming",
	humor: "Humour",
	lifestyle: "Inspiration & Lifestyle",
	creative_hoobies: "DIY",
	luxury: "Luxury",
	mode_accessories: "Fashion & Accessories",
	music: "Music",
	nature_environment: "Nature & Environment",
	news: "News & Trends",
	politic: "Politics",
	science: "Science",
	social: "Social",
	sport_fitness: "Sport & Fitness",
	tech: "Tech",
	vehicules: "Vehicles",
	traval: "Travel",
	photography: "Photography",
	reality_show: "Reality Shows"
};